import * as pdfjs from 'pdfjs3/build/pdf';

if (typeof window !== 'undefined' && pdfjs?.GlobalWorkerOptions) {
  pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version || '3.11.174'}/pdf.worker.min.js`;
}

// Renders page 1 of a PDF (File/Blob) to a PNG blob URL for the preview, and returns the page size in PDF
// points, the coordinate space the certificate-style items are stored in. Caller revokes `url`.
export async function renderPdfFirstPage(fileOrBlob, scale = 2.5) {
  const doc = await pdfjs.getDocument({ data: await fileOrBlob.arrayBuffer() }).promise;
  try {
    const page = await doc.getPage(1);
    const pts = page.getViewport({ scale: 1 });
    const viewport = page.getViewport({ scale });
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(viewport.width);
    canvas.height = Math.round(viewport.height);
    await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise;
    const blob = await new Promise((res, rej) =>
      canvas.toBlob((b) => (b ? res(b) : rej(new Error('PDF render failed'))), 'image/png')
    );
    return { url: URL.createObjectURL(blob), widthPt: pts.width, heightPt: pts.height };
  } finally {
    doc.destroy();
  }
}
